var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var _ = require('underscore');

// Actions
var JobActions = require('../actions/job_actions');

// Stores
var JobStore = require('../stores/job_store');
var LanguageStore = require('../stores/language_store');

// Components
var JobTitle = require('./job_title');
var JobMap = require('./job_map');
var JobDescription = require('./job_description');
var JobApplyButton = require('./job_apply_button');
var JobCallbackButton = require('./job_callback_button');

// Job Area
module.exports = React.createClass({
	
	// Render
  	render: function(){
  		
  		var self = this;
  		var job_map = '';
  		var job_desc = '';
  		var job_filled = '';
  		var job_cover_picture = '';
  		var callback_button = '';
  		
  		//console.log(this.props);
  		if(typeof this.props.job.is_filled != 'undefined'){
  			
  			job_filled = (<div className="filled-job-message">
  				<span className="icon fa fa-info-circle"></span>{LanguageStore.get('job_ad/filled/message')}
  			</div>);
  			
  		} else {
  			
  			if(this.props.job.map_display_mode !== 'none'){
		  		job_map = (<JobMap 
	   					map_display_mode={this.props.job.map_display_mode}
	   					map_zoom_level={this.props.job.map_zoom_level}
	   					env={this.props.env}
	   					address={this.props.job.address}
	   					lat={this.props.job.lat} 
	   					lng={this.props.job.lng} />);
   			}
   			job_desc = (<JobDescription 
      				use_html={this.props.job.use_html}
      				description={this.props.job.description} />);
  		}
  		
  		// Show cover picture instead of map
  		
  		if(typeof this.props.job.show_image_instead_of_map != 'undefined' && (this.props.job.show_image_instead_of_map === true || this.props.job.show_image_instead_of_map === 'true')){
	  		console.log('show cover', this.props);
	  		job_map = '';
	  		
	  		var publish_cover_picture = this.props.job.publish_cover_picture;
	  		
	  		if(publish_cover_picture.indexOf('http://app.srch20.com/srch-api/public/images') != -1){
		  		publish_cover_picture = 'https://images.searchsoftware.nl/'+this.props.env+'/'+publish_cover_picture.split('/').pop()+'?width=1024'
	  		}
	  		
	  		if(typeof publish_cover_picture != 'undefined' && publish_cover_picture != ''){
	  			job_cover_picture = (<div className="job-cover-picture"><img src={publish_cover_picture} /></div>);
	  		}
  		}
  		
  		if(typeof this.props.job.custom_callback_button != 'undefined' && this.props.job.custom_callback_button != ''){
  			//callback_button = (<JobCallbackButton job={this.props.job} />);
  		}
  		
  		var custom_fields_top_el = null;
  		var custom_fields_bottom_el = null;
  		
  		if(self.props.job.custom_fields){
  			
  			var cf_top = _.filter(self.props.job.custom_fields, function(r){ 
  				return r.display_position === 'top' && r.value !== '';
  			});
  			
  			var cf_bottom = _.filter(self.props.job.custom_fields, function(r){ 
  				return r.display_position === 'bottom' && r.value !== '';
  			});
  			  			
  			if(cf_top.length > 0){
	  			custom_fields_top_el = (<ul className="custom-fields top">
	  				{cf_top.map(function(cf){
		  				return (<li key={cf.field}>
		  					<h4>{cf.title}</h4>
		  					<span>{cf.value}</span>
		  				</li>);
	  				})}
	  			</ul>);
  			}
  			
  			if(cf_bottom.length > 0){
	  			custom_fields_bottom_el = (<ul className="custom-fields bottom">
	  				{cf_bottom.map(function(cf){
		  				return (<li key={cf.field}>
		  					<h4>{cf.title}</h4>
		  					<span>{cf.value}</span>
		  				</li>);
	  				})}
	  			</ul>);
  			}
  		}
  		
   		return (
   			<div className="job-area">
   			
   				<JobApplyButton job={this.props.job} env_info={this.props.env_info} />
   				   				
   				<JobTitle 
   					job={this.props.job}
   					env_info={this.props.env_info}
   					title={this.props.job.title}
   					sub_title={this.props.job.sub_title}
   					company_logo={this.props.job.company_logo} />
   				
   				{job_map}
      			
      			{job_cover_picture}
      			
      			<div style={{padding:'0px 50px 0px 50px'}}>
      				{custom_fields_top_el}
      			</div>
      			
      			{job_desc}
      			
      			<div style={{padding:'0px 50px 0px 50px'}}>
      				{custom_fields_bottom_el}
      			</div>
      			
      			<JobApplyButton job={this.props.job} env_info={this.props.env_info} force_display={true} />
      			
      			{callback_button}
      			
      			{job_filled}
      			
	  		</div>
	  	);
	}
});
